export const GOTO_NEXT_STEP = 'GOTO_NEXT_STEP';
export const GOTO_PREVIOUS_STEP = 'GOTO_PREVIOUS_STEP';
export const RESET_ASSIGN_STATE = 'RESET_ASSIGN_STATE';
